export default __webpack_public_path__ + "static/media/img-51.62e4534e.jpg";